// extracted by mini-css-extract-plugin
export default {"headerCycleWrapper":"CiklusDetaljno_headerCycleWrapper__mEXBv","headerCycleTitle":"CiklusDetaljno_headerCycleTitle__BeJmg"};